import { render, staticRenderFns } from "./employee-table.view.vue?vue&type=template&id=28086dc9&scoped=true&"
import script from "./employee-table.view.vue?vue&type=script&lang=ts&"
export * from "./employee-table.view.vue?vue&type=script&lang=ts&"
import style0 from "./employee-table.view.vue?vue&type=style&index=0&id=28086dc9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28086dc9",
  null
  
)

export default component.exports